import * as React from 'react'
import { SVGProps } from 'react'
export const HelloIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    {...props}
  >
    <path
      fill="#858585"
      d="m12.303 8.662-6.178 6.213c-5.827 5.793-5.827 15.207 0 21 5.828 5.792 15.207 5.828 21 0l10.5-10.5a4.311 4.311 0 0 0 0-6.195 2.872 2.872 0 0 0-.648-.56l.648-.683a4.311 4.311 0 0 0 0-6.195c-.245-.28-.578-.525-.875-.717.665-1.61.367-3.535-.945-4.848-1.523-1.522-3.885-1.68-5.6-.49a4.405 4.405 0 0 0-6.79-.735l-4.392 4.393a4.15 4.15 0 0 0-.56-.683 4.428 4.428 0 0 0-6.16 0Zm2.467 2.486a.866.866 0 0 1 1.242 0c.35.35.35.892 0 1.242l-5.565 5.565a5.25 5.25 0 0 1 0 7.42l2.468 2.468a8.75 8.75 0 0 0 1.96-9.38L25.9 7.436a.846.846 0 0 1 1.225 0c.332.35.367.893 0 1.243l-8.032 8.05 2.467 2.468L32.078 8.68a.866.866 0 0 1 1.242 0c.35.35.35.893 0 1.242L22.802 20.44l2.468 2.467 8.662-8.662a.866.866 0 0 1 1.243 0c.35.35.35.893 0 1.243l-9.905 9.887 2.468 2.485 6.194-6.195a.866.866 0 0 1 1.243 0c.35.35.35.893 0 1.242l-10.5 10.518a11.365 11.365 0 0 1-16.083 0 11.365 11.365 0 0 1 0-16.082l6.178-6.195ZM40.25 29.75c0 5.792-4.708 10.5-10.5 10.5v-2.625c4.375 0 7.875-3.5 7.875-7.875h2.625Zm-38.5-17.5c0-5.793 4.707-10.5 10.5-10.5v2.625a7.842 7.842 0 0 0-7.875 7.875H1.75Z"
    />
  </svg>
)
